





















































































































































































































































































import {
    defineComponent,
    reactive,
    toRefs,
    computed,
    ref,
    Ref,
    onMounted,
    PropType,
    watch,
} from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { Status, ApiInfoStatus } from '@/type/enums';
import appSecret from '../app-secret.vue';
import imgUpload from '@/components/img-upload/index.vue';
import entry from '@/components/entry/index.vue';
import InputSecret from '@/components/input/secret.vue';
import { convertApiStatusText } from '../../util';
import { skipLoadingWrapper } from '@/utils/helper';
import backToPrevious from '../back-to-pre.vue';
import { MerchantModel, CategoryInfoType } from './model';

export default defineComponent({
    name: 'merchant-detail',

    components: {
        appSecret,
        imgUpload,
        entry,
        backToPrevious,
        InputSecret,
    },
    setup(props, context) {
        const apiInfoStatus: any = ApiInfoStatus;
        const status = Status;
        const isEditBase = ref(false);
        const isBaseEditDisable = ref(false);
        const signSecret = ref('0000000000000000000000');
        const messageSecret = ref('0000000000000000000000');
        const convertApiStatus = convertApiStatusText;
        const merchantModel = useApolloModel(MerchantModel);
        const list: Ref<Record<string, any>> = ref({
            appId: '',
            name: '',
            categoryId: -1, // 应用类型
            desc: '',
            icon: '',
            prd: {
                path: '',
                fileName: '',
            },
            mrd: {
                path: '',
                fileName: '',
            },
            redirectUri: '',
            website: '',
        });

        const isShowApiInfo = computed(() => {
            return (
                merchantModel.appInfo.status !== status.pending &&
                merchantModel.appInfo.status !== status.fail
            );
        });
        const appId = computed(() => {
            return context.root.$route.params.appId;
        });
        const isAppEditDisable = computed(() => {
            return (
                isBaseEditDisable.value ||
                merchantModel.appInfo.updateApprovalStatus === 1
            );
        });
        const categoryName = computed(() => {
            if (merchantModel.appInfo.category.children?.categoryName) {
                return `${merchantModel.appInfo.category.categoryName}
                    -
                    ${merchantModel.appInfo.category.children.categoryName}`;
            }
            return merchantModel.appInfo.category.categoryName;
        });
        const mrdDownloadUrl = computed(() => {
            return list.value.mrd.path
                ? `https://${window.location.host}/portal/file/secure/download/${list.value.mrd.path}`
                : '';
        });
        const prdDownloadUrl = computed(() => {
            return list.value.prd.path
                ? `https://${window.location.host}/portal/file/secure/download/${list.value.prd.path}`
                : '';
        });

        function getStatus(status: number): string {
            switch (status) {
                case Status.pass:
                    return '审核通过';
                case Status.pending:
                    return '审核中';
                case Status.fail:
                    return '已驳回';
                default:
                    return '其他';
            }
        }

        async function handleDetailSelfApiApply(index: number) {
            try {
                const curinfo = merchantModel.apiInfos[index];
                const res: any = await merchantModel.merchantApplyScope({
                    appId: appId.value,
                    scopeName: curinfo.scopeName,
                });
                if (res.result === 1) {
                    context.root.$message({
                        type: 'success',
                        message: '您的申请已提交',
                        customClass: 'message-custom message-success-custom',
                        iconClass: 'message-success-custom-icon',
                    });
                    curinfo.status = apiInfoStatus.applying;
                } else {
                    context.root.$message.error(
                        res.error_msg || '请求出错，请重试',
                    );
                }
            } catch (e) {
                context.root.$message.error('服务器错误');
            }
        }
        const detailSelfApiApply = skipLoadingWrapper(handleDetailSelfApiApply);

        const canBaseSubmit = computed(() => {
            return !!(
                list.value.categoryId &&
                list.value.name.length >= 2 &&
                list.value.name.length <= 20 &&
                list.value.desc &&
                list.value.icon &&
                list.value.redirectUri &&
                list.value.website
            );
        });
        function init() {
            for (const v in list.value) {
                if (v === 'prd') {
                    list.value.prd.path = merchantModel.appInfo.prd;
                    list.value.prd.fileName = merchantModel.appInfo.prdFileName;
                    continue;
                }
                if (v === 'mrd') {
                    list.value.mrd.path = merchantModel.appInfo.mrd;
                    list.value.mrd.fileName = merchantModel.appInfo.mrdFileName;
                    continue;
                }
                // @ts-ignore
                list.value[v] = merchantModel.appInfo[v];
            }
        }

        function handleError(msg: string) {
            context.root.$message({
                type: 'error',
                message: msg || '数据更新失败，请重试',
                customClass: 'message-custom message-error-custom',
                iconClass: 'message-error-custom-icon',
            });
        }
        async function refresh() {
            const res = await merchantModel.merchantAppInfo({
                appId: appId.value,
            });
            if (res.result === 1) {
                init();
                return;
            }
            handleError(res.error_msg);
        }
        async function cancelEditBase() {
            isEditBase.value = false;
            const refreshInfo = await refresh();
        }
        async function handleUpdateBase() {
            if (!canBaseSubmit.value) {
                return;
            }
            const res = await merchantModel.updateMerchant({
                appId: appId.value,
                name: list.value.name,
                desc: list.value.desc,
                icon: list.value.icon,
                redirectUri: list.value.redirectUri,
                website: list.value.website,
            });
            if (res.result === 1) {
                context.root.$message({
                    type: 'success',
                    message: '提交审核成功',
                    customClass: 'message-custom message-success-custom',
                    iconClass: 'message-success-custom-icon',
                });
                await merchantModel.merchantAppInfo({ appId: appId.value });
                isBaseEditDisable.value = true;
                isEditBase.value = false;
                return;
            }
            handleError(res.error_msg);
        }

        const updateBase = skipLoadingWrapper(handleUpdateBase);

        async function getSignSecret() {
            const res = await merchantModel.getSignSecret({
                appId: appId.value,
            });
            if (res.result !== 1) {
                handleError(res.error_msg);
                return false;
            }
            signSecret.value = res.signSecret;
            return true;
        }

        async function getMessageSecret() {
            const res = await merchantModel.getMessageSecret({
                appId: appId.value,
            });
            if (res.result !== 1) {
                handleError(res.error_msg);
                return false;
            }
            messageSecret.value = res.messageSecret;
            return true;
        }

        onMounted(async () => {
            const res = await merchantModel.merchantAppInfo({
                appId: appId.value,
            });
            await merchantModel.merchantAppScopes({ appId: appId.value });
            if (res.result !== 1) {
                context.root.$message({
                    type: 'error',
                    message: res.error_msg,
                    customClass: 'message-custom message-error-custom',
                    iconClass: 'message-error-custom-icon',
                });
            } else {
                init();
            }
        });

        return {
            isShowApiInfo,
            appId,
            detailSelfApiApply,
            convertApiStatus,
            apiInfoStatus,
            isEditBase,
            isAppEditDisable,
            cancelEditBase,
            canBaseSubmit,
            updateBase,
            list,
            getStatus,
            merchantModel,
            status,
            categoryName,
            messageSecret,
            signSecret,
            getSignSecret,
            getMessageSecret,
            mrdDownloadUrl,
            prdDownloadUrl,
        };
    },
});
